import MainPageCentral from '@/screens/central/MainPage'
import HomeCentral from '@/screens/central/Home'
import Processos from '@/screens/central/processos/Processos'
import DetalhesProcesso from '@/screens/central/processos/DetalhesProcesso'
import CentralMensagens from '@/screens/central/components/centralMensagens/AppCentralMensagens'
import ConversaMensagens from '@/screens/central/components/centralMensagens/AppConversaMensagens'
import CalculoBoleto from '@/screens/central/components/vtn/AppCalculoVtn'
import Comunicacao from '@/screens/central/comunicacao/Comunicacao'
import InformacoesCadastro from '@/components/InformacoesCadastro'
import GerenciamentoDaes from '../screens/central/components/centralMensagens/AppGerenciamentoDaes'
import NovaConversa from '@/screens/central/comunicacao/NovaConversa'
import VisualizarConversa from '@/screens/central/comunicacao/VisualizarConversa'
import IncluirCredenciado from '@/screens/central/credenciados/IncluirCredenciado'
import PERFIL from '@/constants/perfil'
import VisualizarVtn from '@/screens/analise/vtn/VisualizarVtn.vue'
import AntecipacaoParcela from '@/screens/analise/vtn/AntecipacaoParcela.vue'
import VisualizarVtnRR from '@/screens/analise/vtn/VisualizarVtnRR.vue'
import AnteciparParcelaPA from '@/screens/analise/vtn/AntecipacaoParcelaPa.vue'
import EmitirDaeAntecipar from '@/screens/analise/EmitirDaeAnteciparParcela'
import Conflitos from '../screens/central/comunicacao/Conflitos.vue'
import ConflitosShape from '../screens/central/comunicacao/ConflitosShape.vue'

// ROUTES ESTADO PROFILE
const routesEstado = require('./routes-' + process.env.ESTADO)

const setRouteGroup = group => {
  return { routeGroup: group }
}

const setParentRouteGroup = group => {
  return { parentRouteGroup: group }
}

const perfisCentral = [PERFIL.CENTRAL_DO_INTERESSADO.EXTERNO.codigo, PERFIL.CENTRAL_DO_INTERESSADO.PREFEITURA.codigo, PERFIL.CENTRAL_DO_INTERESSADO.CONSULTOR_EXTERNO.codigo, PERFIL.CENTRAL_DO_INTERESSADO.CONSULTOR_EXTERNO_DIVERSOS.codigo]

const central = [
  {
    path: '/central',
    component: MainPageCentral,
    redirect: { name: 'central/home' },
    children: [
      {
        path: 'home',
        name: 'central/home',
        meta: {
          codigoModulo: PERFIL.CENTRAL_DO_INTERESSADO.CODIGO_MODULO,
          hideSideMenu: true
        },
        component: HomeCentral
      },

      /* CADASTROS */
      ...routesEstado.routes.CADASTROS,

      /* COMUNICAÇÃO */
      {
        path: 'comunicacao',
        name: 'central/comunicacao',
        component: Comunicacao,
        props: true,
        meta: {
          menu: 'central/comunicacao',
          perfis: perfisCentral,
          ...setRouteGroup('CENTRAL_COMUNICACAO')
        }
      },
      {
        path: 'conflitos',
        name: 'central/conflitos',
        component: Conflitos,
        props: true,
        meta: {
          menu: 'central/conflitos',
          perfis: perfisCentral,
          ...setRouteGroup('CENTRAL_CONFLITOS')
        }
      },
      {
        path: 'conflitos/shape/:id',
        name: 'central/ShapeConflitos',
        component: ConflitosShape,
        props: true,
        meta: {
          menu: 'central/ShapeConflitos',
          perfis: perfisCentral,
          ...setRouteGroup('CENTRAL_CONFLITOS')
        }
      },
      {
        path: 'conversas/new',
        name: 'conversas/new',
        component: NovaConversa,
        meta: {
          menu: 'central/comunicacao',
          perfis: perfisCentral
        }
      },
      {
        path: 'conversa/visualizar/:idConversa',
        name: 'conversa/visualizar/',
        component: VisualizarConversa,
        meta: {
          menu: 'central/comunicacao',
          perfis: perfisCentral
        }
      },

      /* PROCESSOS */
      {
        path: 'processos',
        name: 'central/processos',
        component: Processos,
        meta: {
          menu: 'central/processos',
          perfis: perfisCentral,
          ...setRouteGroup('CENTRAL_PROCESSOS')
        }
      },
      {
        path: 'processos/detalhes-processo/:idCadastro/:id',
        name: 'detalhes-processo',
        component: DetalhesProcesso,
        props: true,
        redirect: { name: 'informacoesCadastro' },
        children: [
          {
            path: 'informacoesCadastro',
            name: 'informacoesCadastro',
            component: InformacoesCadastro,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_INFO_CADASTRO'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          },
          {
            path: 'caixa-entrada',
            name: 'caixa-entrada',
            component: CentralMensagens,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_MENSAGENS'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          },
          {
            path: 'gerenciamento-daes',
            name: 'gerenciamento-daes',
            component: GerenciamentoDaes,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          },
          {
            path: 'conversa/:idConversa',
            name: 'conversa',
            component: ConversaMensagens,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_MENSAGENS'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          },
          {
            path: 'calculo-pagamento/:idVtn',
            name: 'calculo-pagamento',
            component: CalculoBoleto,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          },
          {
            path: 'vtn/escolher-forma-pagamento',
            name: 'vtn/escolher-forma-pagamento',
            component: VisualizarVtn,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: false
            }
          },
          {
            path: 'vtnrr/escolher-forma-pagamento',
            name: 'vtnrr/escolher-forma-pagamento',
            component: VisualizarVtnRR,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: false
            }
          },
          {
            path: 'vtn/antecipacao-parcela',
            name: 'vtn/antecipacao-parcela',
            component: AntecipacaoParcela,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: false
            }
          },
          {
            path: 'vtn/antecipacao-parcela-PA',
            name: 'vtn/antecipacao-parcela-PA',
            component: AnteciparParcelaPA,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          },
          {
            path: 'emitirDaeAntecipar/vtn/:idProcesso',
            name: 'emitirDaeAntecipar',
            component: EmitirDaeAntecipar,
            props: true,
            meta: {
              perfis: perfisCentral,
              ...setRouteGroup('CENTRAL_DAES'),
              ...setParentRouteGroup('CENTRAL_PROCESSOS'),
              isSubmenu: true
            }
          }
        ]
      },
      {
        path: 'listagem/credenciado',
        name: 'listagem/credenciado',
        component: IncluirCredenciado,
        meta: {
          menu: 'listagem/credenciado',
          perfis: perfisCentral,
          ...setRouteGroup('CENTRAL_VISTORIADOR_CREDENCIADO')
        }
      },
      {
        path: '*',
        redirect: '/receptor'
      }
    ]
  }
]

export default central



// WEBPACK FOOTER //
// ./src/router/central.js